module.exports = __webpack_public_path__ + "img/photographer-mockup.c611b37d.jpg";